import { FEATURE_KEYS, I18N_KEYS, MODULE_KEYS, OPERATION_IDS, TELEMETRY_IDS } from './ids.js';
import { MARKET_PRICE_ROUTE_IDS } from './market-price-route-ids.js';
const base = {
    schemaVersion: 1,
    module: MODULE_KEYS.MARKET_DATA,
    feature: FEATURE_KEYS.DATA_MARKET_PRICES,
    telemetryId: TELEMETRY_IDS.HUB_DATA_MARKET,
    accessibilityLabelKey: I18N_KEYS.CARD_MARKET_PRICES_TITLE,
    privacyClassification: 'CONFIDENTIAL',
    auditPolicy: 'ALWAYS',
    owner: 'market-data',
    layoutId: 'app',
    authentication: 'authenticated',
    availability: 'AVAILABLE',
    breadcrumbKeys: [I18N_KEYS.CARD_MARKET_PRICES_TITLE],
    navigationPlacement: 'hidden',
    allowedPersonas: ['ORG_ADMIN'],
};
export const MARKET_PRICE_MANAGEMENT_ROUTES = Object.freeze([
    {
        ...base,
        id: 'route-data-market-price-create',
        routeId: MARKET_PRICE_ROUTE_IDS.CREATE,
        path: '/data/market-prices/new',
        pageId: 'page-data-market-price-create',
        titleKey: I18N_KEYS.CARD_MARKET_PRICES_TITLE,
        operationId: OPERATION_IDS.MARKET_DATA_CREATE,
    },
    {
        ...base,
        id: 'route-data-market-price-edit',
        routeId: MARKET_PRICE_ROUTE_IDS.EDIT,
        path: '/data/market-prices/:id/edit',
        pageId: 'page-data-market-price-edit',
        titleKey: I18N_KEYS.CARD_MARKET_PRICES_TITLE,
        operationId: OPERATION_IDS.MARKET_DATA_UPDATE,
    },
]);
